document.addEventListener('DOMContentLoaded', () => {
  const WORKER_URL =
    'https://astroca-link-card.hideki-naito.workers.dev/';

  const articleBody = document.querySelector(
    '[data-astroca-link-cards]'
  );

  if (!articleBody) return;

  const KNOWN_SITES = {
    'suntory.co.jp': 'サントリー',
    'asahibeer.co.jp': 'アサヒビール',
    'sapporobeer.jp': 'サッポロビール',
    'heineken.com': 'Heineken',
    'athleticbrewing.com': 'Athletic Brewing'
  };

  const candidates = Array.from(
    articleBody.querySelectorAll('p, div')
  ).filter((element) => {
    // 内部リンクカードには絶対に触らない
    if (
      element.closest('.astroca-link-card') ||
      element.querySelector('.astroca-link-card')
    ) {
      return false;
    }

    // 大きな親要素は対象外
    if (
      element.querySelector(':scope > p, :scope > div')
    ) {
      return false;
    }

    const text = cleanText(element.textContent);

    return /^https?:\/\/\S+$/.test(text);
  });

  candidates.forEach((element) => {
    processExternalUrl(element);
  });


  async function processExternalUrl(element) {
    const rawText = cleanText(element.textContent);

    let targetUrl;

    try {
      const existingAnchor =
        element.querySelector('a[href]');

      targetUrl = new URL(
        existingAnchor ? existingAnchor.href : rawText,
        window.location.origin
      );
    } catch {
      return;
    }

    const host =
      targetUrl.hostname.replace(/^www\./, '');

    // ASTROCA内部URLは一切触らない
    if (host === 'astroca.jp') {
      return;
    }

    const siteName =
      KNOWN_SITES[host] || host;

    const card = createFallbackCard(
      targetUrl,
      siteName
    );

    element.replaceWith(card);

    try {
      const apiUrl =
        `${WORKER_URL}?url=${encodeURIComponent(
          targetUrl.href
        )}`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        return;
      }

      const data = await response.json();

      if (!data.ok) {
        return;
      }

      enhanceCard(card, targetUrl, data);

    } catch (error) {
      console.warn(
        'ASTROCA External Card:',
        error,
        targetUrl.href
      );
    }
  }


  function createFallbackCard(
    targetUrl,
    siteName
  ) {
    const card =
      document.createElement('a');

    card.className =
      'astroca-external-card astroca-external-card--fallback';

    card.href = targetUrl.href;

    const iconWrap =
      document.createElement('div');

    iconWrap.className =
      'astroca-external-card__favicon-wrap';

    const icon =
      document.createElement('img');

    icon.className =
      'astroca-external-card__favicon';

    icon.src =
      `${targetUrl.protocol}//${targetUrl.hostname}/favicon.ico`;

    icon.alt = '';
    icon.loading = 'lazy';

    icon.addEventListener(
      'error',
      () => {
        iconWrap.remove();
      },
      { once: true }
    );

    iconWrap.appendChild(icon);

    const content =
      document.createElement('div');

    content.className =
      'astroca-external-card__content';

    const title =
      document.createElement('strong');

    title.className =
      'astroca-external-card__title';

    title.textContent =
      KNOWN_SITES[
        targetUrl.hostname.replace(/^www\./, '')
      ]
        ? `${siteName}公式サイト`
        : 'リンク先を見る';

    const domain =
      document.createElement('span');

    domain.className =
      'astroca-external-card__site';

    domain.textContent =
      targetUrl.hostname.replace(/^www\./, '');

    content.appendChild(title);
    content.appendChild(domain);

    card.appendChild(iconWrap);
    card.appendChild(content);

    return card;
  }


  function enhanceCard(
    card,
    targetUrl,
    data
  ) {
    const title =
      cleanText(data.title);

    const description =
      cleanDescription(data.description);

    const image =
      cleanText(data.image);

    const siteName =
      cleanText(data.siteName) ||
      targetUrl.hostname.replace(/^www\./, '');

    card.classList.remove(
      'astroca-external-card--fallback'
    );

    card.classList.add(
      'astroca-external-card--loaded'
    );

    const oldFavicon =
      card.querySelector(
        '.astroca-external-card__favicon-wrap'
      );

    if (oldFavicon) {
      oldFavicon.remove();
    }

    if (image) {
      const imageWrap =
        document.createElement('div');

      imageWrap.className =
        'astroca-external-card__image-wrap';

      const img =
        document.createElement('img');

      img.className =
        'astroca-external-card__image';

      img.src = image;
      img.alt = '';
      img.loading = 'lazy';

      img.addEventListener(
        'error',
        () => {
          imageWrap.remove();
        },
        { once: true }
      );

      imageWrap.appendChild(img);
      card.prepend(imageWrap);
    }

    const content =
      card.querySelector(
        '.astroca-external-card__content'
      );

    const titleElement =
      card.querySelector(
        '.astroca-external-card__title'
      );

    const siteElement =
      card.querySelector(
        '.astroca-external-card__site'
      );

    if (titleElement && title) {
      titleElement.textContent = title;
    }

    if (description) {
      const descriptionElement =
        document.createElement('span');

      descriptionElement.className =
        'astroca-external-card__description';

      descriptionElement.textContent =
        truncateText(description, 160);

      if (titleElement) {
        titleElement.insertAdjacentElement(
          'afterend',
          descriptionElement
        );
      }
    }

    if (siteElement) {
      siteElement.textContent = siteName;
    }

    card.href = targetUrl.href;
  }


  function cleanText(value) {
    return String(value || '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function cleanDescription(value) {
    if (!value) return '';

    const textarea =
      document.createElement('textarea');

    textarea.innerHTML =
      String(value);

    const decoded =
      textarea.value;

    const div =
      document.createElement('div');

    div.innerHTML = decoded;

    return cleanText(
      div.textContent ||
      div.innerText ||
      decoded
    );
  }


  function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }

    return (
      text.slice(0, maxLength).trim() +
      '…'
    );
  }
});